import { useNavigate } from "react-router-dom";
import { LogOut, ExternalLink, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ClientLayout({ children, title, subtitle }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-20 backdrop-blur-md bg-white/95 border-b border-slate-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/studio-castelli-logo.jpg" alt="Studio Castelli" className="w-40 h-auto" data-testid="header-logo" />
            <p className="text-[10px] uppercase tracking-[0.2em] text-[#3C763D] font-semibold hidden sm:block">Area Riservata Clienti</p>
          </div>
          <div className="flex items-center gap-2 sm:gap-4">
            <span
              data-testid="user-role-badge"
              className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-green-50 text-[#3C763D] border border-green-200"
            >
              <ShieldCheck className="w-3.5 h-3.5" />
              {user?.name}
            </span>
            <a
              href="https://www.studiocastelli.it"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="back-to-site-link"
              className="hidden md:flex items-center gap-1.5 text-xs text-slate-400 hover:text-[#3C763D] transition-colors duration-200"
            >
              <ExternalLink className="w-3.5 h-3.5" />
              studiocastelli.it
            </a>
            <button
              onClick={handleLogout}
              data-testid="logout-button"
              className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm text-slate-500 hover:bg-green-50 hover:text-navy transition-colors duration-200"
            >
              <LogOut className="w-4 h-4" />
              <span className="hidden sm:inline">Esci</span>
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        <div className="mb-8">
          <h1 className="font-display text-3xl sm:text-4xl font-bold text-navy tracking-tight">{title}</h1>
          {subtitle && <p className="text-base sm:text-lg text-muted-foreground mt-1">{subtitle}</p>}
        </div>
        {children}
      </main>
    </div>
  );
}
